import React from "react";

/**
 * Global React error boundary. Prevents the "white screen of death" when any
 * child component throws during render / lifecycle. Shows a friendly fallback
 * with actions to recover, and logs the error in console for diagnosis.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[Emmepi ErrorBoundary]", error, info?.componentStack);
  }

  reset = () => this.setState({ hasError: false, error: null });

  reload = () => {
    try { this.reset(); } catch { /* noop */ }
    window.location.reload();
  };

  goHome = () => {
    try { this.reset(); } catch { /* noop */ }
    window.location.href = "/";
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    const msg = String(this.state.error?.message || this.state.error || "Errore imprevisto");
    return (
      <div
        data-testid="error-boundary-fallback"
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "24px",
          background: "#f8fafc",
          fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
        }}
      >
        <div
          style={{
            maxWidth: 520,
            width: "100%",
            background: "#fff",
            borderRadius: 12,
            border: "1px solid #e2e8f0",
            padding: 28,
            boxShadow: "0 10px 30px rgba(15,23,42,.08)",
          }}
        >
          <div style={{ fontSize: 12, letterSpacing: ".1em", color: "#64748b", textTransform: "uppercase", fontWeight: 700 }}>
            Emmepi Service
          </div>
          <h1 style={{ margin: "8px 0 6px", fontSize: 22, color: "#0f172a", fontWeight: 800 }}>
            Ops, qualcosa è andato storto
          </h1>
          <p style={{ margin: 0, color: "#475569", fontSize: 14, lineHeight: 1.5 }}>
            La schermata ha avuto un problema temporaneo. Puoi ricaricare la pagina o tornare alla home. I tuoi dati sono al sicuro sul server.
          </p>
          <div style={{
            marginTop: 16, padding: "10px 12px", background: "#f1f5f9",
            border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 12, color: "#334155",
            wordBreak: "break-word", fontFamily: "ui-monospace,SFMono-Regular,Menlo,monospace"
          }}>
            {msg}
          </div>
          <div style={{ display: "flex", gap: 10, marginTop: 20, flexWrap: "wrap" }}>
            <button
              data-testid="error-reload-btn"
              onClick={this.reload}
              style={{
                background: "#1e40af", color: "#fff", border: 0, padding: "10px 18px",
                borderRadius: 8, fontWeight: 700, cursor: "pointer", fontSize: 14,
              }}
            >
              Ricarica pagina
            </button>
            <button
              data-testid="error-home-btn"
              onClick={this.goHome}
              style={{
                background: "#fff", color: "#0f172a", border: "1px solid #cbd5e1",
                padding: "10px 18px", borderRadius: 8, fontWeight: 600, cursor: "pointer", fontSize: 14,
              }}
            >
              Torna alla home
            </button>
          </div>
        </div>
      </div>
    );
  }
}
